module.exports = __webpack_public_path__ + "static/media/09.c1db913b.jpg";